import { render, staticRenderFns } from "./PhotoPage.vue?vue&type=template&id=f5855d4e&scoped=true"
import script from "./PhotoPage.vue?vue&type=script&lang=js"
export * from "./PhotoPage.vue?vue&type=script&lang=js"
import style0 from "./PhotoPage.vue?vue&type=style&index=0&id=f5855d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5855d4e",
  null
  
)

export default component.exports